<!-- Base.Empty.vue (client-lms) -->
<template>
  <div class="lms_empty">
    <img
      v-if="imgSrc"
      :src="imgSrc"
      alt=""
      class="lms_empty_icon"
    />
    <img
      v-else-if="type === 'search'"
      src="@/assets/common/images/lms/empty_search.png"
      alt=""
      class="lms_empty_icon"
    />
    <img
      v-else
      src="@/assets/common/images/lms/empty_nodata.svg"
      alt=""
      class="lms_empty_icon"
    />
    <p class="lms_empty_text">{{ message }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps({
  type: { type: String, default: "nodata" },
  message: { type: String, default: "데이터가 없습니다." },
  imgSrc: { type: String, default: "" },
});
</script>
